import { AspectRatioDefault } from './aspect-ratio-default';

export default AspectRatioDefault;
export const AspectRatioBox = AspectRatioDefault;
export * from './aspect-ratio-default';
